import React from "react";
import {
  AHTeamIcon,
  AHTeamIconCircle,
  AHText,
  Box,
  useLayoutContext,
  useTheme,
} from "arkh";
import { graphql, useFragment } from "react-relay";
import { KPITeamIcon_Team$key } from "./__generated__/KPITeamIcon_Team.graphql";

export function KPITeamIcon(props: {
  team: KPITeamIcon_Team$key;
  count: number;
}) {
  const theme = useTheme();
  const layout = useLayoutContext();

  const data = useFragment(
    graphql`
      fragment KPITeamIcon_Team on Team {
        id
        color
        icon
      }
    `,
    props.team
  );

  return (
    <Box spaceLeft="xxsmall" spaceVertical="xxsmall" key={data.id}>
      {props.count > 1 ? (
        <Box
          style={{
            backgroundColor: data.color ?? theme.primary,
            borderRadius: layout.circle.small / 2,
            height: layout.circle.small,
            flexDirection: "row",
            alignItems: "center",
          }}
          spaceHorizontal="xsmall"
        >
          <AHTeamIcon type={data.icon} color="lightText" size="xxsmall" />
          <AHText color="lightText" spaceLeft="xxsmall" type="info-small">
            {props.count}
          </AHText>
        </Box>
      ) : (
        <AHTeamIconCircle
          size="small"
          color={data.color ?? null}
          type={data.icon ?? null}
        />
      )}
    </Box>
  );
}
